class StTestimonialVideo {
  constructor(container) {
    this.container = container;

    this.selectors = {
      swiperContainer: "[data-st-swiper]",
      prevBtn: "[data-st-slider-prev]",
      nextBtn: "[data-st-slider-next]",
      videoTrigger: "[data-st-video-trigger]",
      modal: "[data-st-video-modal]",
      modalClose: "[data-st-modal-close]",
      videoPlayer: "[data-st-video-player]",
    };

    // Modal Elements
    this.modal = this.container.querySelector(this.selectors.modal);
    if (!this.modal) console.warn("ST Testimonial Video: Modal not found");

    this.videoPlayer = this.modal
      ? this.modal.querySelector(this.selectors.videoPlayer)
      : null;
    this.closeButtons = this.modal
      ? this.modal.querySelectorAll(this.selectors.modalClose)
      : [];
    this.triggers = this.container.querySelectorAll(
      this.selectors.videoTrigger
    );

    this.init();
  }

  init() {
    this.initSwiper();
    this.setupStModal();
  }

  initSwiper() {
    const swiperEl = this.container.querySelector(
      this.selectors.swiperContainer
    );
    const prevBtn = this.container.querySelector(this.selectors.prevBtn);
    const nextBtn = this.container.querySelector(this.selectors.nextBtn);

    if (!swiperEl) return;

    if (typeof Swiper === "undefined") {
      console.warn(
        "Swiper is not defined. Please ensure Swiper library is loaded."
      );
      return;
    }

    this.swiper = new Swiper(swiperEl, {
      slidesPerView: 1.2,
      spaceBetween: 24,
      grabCursor: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        560: {
          slidesPerView: 2.2,
        },
        960: {
          slidesPerView: 4,
        },
      },
    });
  }

  // --- Modal Logic ---
  setupStModal() {
    if (!this.modal || !this.videoPlayer) return;

    // 1. Open Modal
    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const url = trigger.getAttribute("data-video-url");
        this.openStModal(url);
      });
    });

    // 2. Close on Button Click
    this.closeButtons.forEach((btn) => {
      btn.addEventListener("click", () => this.closeStModal());
    });

    // 3. Close on Backdrop Click
    this.modal.addEventListener("click", (e) => {
      // Ensure we are clicking on the backdrop, not the content inside
      if (
        e.target === this.modal ||
        e.target.hasAttribute("data-st-modal-close")
      ) {
        this.closeStModal();
      }
    });

    // 4. Close on ESC Key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.modal.classList.contains("is-active")) {
        this.closeStModal();
      }
    });
  }

  openStModal(videoUrl) {
    if (!videoUrl) return;
    this.videoPlayer.src = videoUrl;
    this.modal.classList.add("is-active");
    this.videoPlayer
      .play()
      .catch((e) => console.log("Auto-play prevented:", e));
    document.body.style.overflow = "hidden";
  }

  closeStModal() {
    this.modal.classList.remove("is-active");
    this.videoPlayer.pause();
    this.videoPlayer.currentTime = 0;
    this.videoPlayer.src = "";
    document.body.style.overflow = "";
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(
    "[data-st-testimonial-video-section]"
  );
  sections.forEach((section) => new StTestimonialVideo(section));
});

// Handle Shopify section load (for theme editor)
document.addEventListener("shopify:section:load", (event) => {
  const section = event.target.querySelector(
    "[data-st-testimonial-video-section]"
  );
  if (section) new StTestimonialVideo(section);
});
